module.exports = __webpack_public_path__ + "static/icon_buyStep3-2b20b0fe40ceb165264342fa95b061cd.png";